// Horizontal scrolling timeline: toggles edge-fade gradients based on scroll position (mobile/tablet only)
export default function timelineInit() {
    const mq = window.matchMedia("(max-width: 1199.98px)");

    const scrollContainer = document.querySelector(".scroll-container");
    const timelineContainer = document.querySelector(".timeline-container");

    if (!scrollContainer || !timelineContainer) return;

    function toggleGradient() {
        let scrolledLeft = scrollContainer.scrollLeft === 0;
        let scrolledRight = scrollContainer.scrollLeft + scrollContainer.clientWidth === scrollContainer.scrollWidth;

        timelineContainer.classList.toggle("scrolled-right", !scrolledLeft);
        timelineContainer.classList.toggle("scrolled-left", !scrolledRight);
    }

    // store reference so we can remove it later
    const onScroll = () => toggleGradient();

    const updateTimelineBehavior = (e) => {
        if (e.matches) {
            scrollContainer.addEventListener("scroll", onScroll);
            toggleGradient(); // optional: set initial state
        } else {
            scrollContainer.removeEventListener("scroll", onScroll);
        }
    };

    // run once
    updateTimelineBehavior(mq);

    // listen for changes
    mq.addEventListener("change", updateTimelineBehavior);
}
